import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Job } from '@contracts/interfaces/job.interface';
import { JobService } from 'src/app/services/job.service';
import { is_phone_number_a_mobile, phone_number } from 'src/app/tools/phone-number';
import { TemplateService } from '../../services/template.service';
import { SendSMSResultDialog } from './send-sms-result.dialog';

export interface SendSMSDialogResult {
  job: any;
  body: string;
}

@Component({
  selector: 'ap-send-sms-dialog',
  templateUrl: 'send-sms.dialog.html',
  styleUrls: ['./send-sms.dialog.scss']
})
export class SendSMSDialog {

  body: string;
  isSending = false;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<SendSMSDialog>,
      public dialog: MatDialog,
      public jobService: JobService,
      public templateService: TemplateService
      ) {
        this.body = data.template;
      }

    confirm() {
      if (this.isSending) {
        return;
      }

      if (!is_phone_number_a_mobile(this.data.customer.phone)) {
        this.openResultDialog('error', 'SMS failed to send because this customer does not have a valid mobile number.');
        return;
      }

      this.isSending = true;

      // Prep it for Telnyxs expectations
      let number = "+61" + phone_number(this.data.customer.phone).substring(1);
      const body = this.body;

      this.jobService.create({
        job: Job.SMS,
        date: {
            start: new Date()
        },
        data: {
          to: number,
          body
        }
      }).subscribe({
        next: (job: any) => {
          this.isSending = false;
          this.openResultDialog('success', 'SMS sent successfully.');
          this.dialogRef.close({
            job,
            body
          } as SendSMSDialogResult);
        },
        error: () => {
          this.isSending = false;
          this.openResultDialog('error', 'SMS failed to send. Please try again.');
        }
      });
    }

    private openResultDialog(status: 'success' | 'error', message: string) {
      this.dialog.open(SendSMSResultDialog, {
        width: '420px',
        data: {
          status,
          message
        }
      });
    }
}
